import { useQuery } from '@tanstack/react-query';
import type { AgentApiCandidateBoardsIndex } from '@/types/serializers';
import { fetchJson } from '@/utils/apiFetch';

export default function useFetchCandidateBoards() {
  return useQuery({
    queryKey: ['candidateBoards'],
    queryFn: async () => {
      const data = await fetchJson<AgentApiCandidateBoardsIndex>(
        `/agent/api/candidate_boards.json`
      );

      return data;
    },
  });
}
